module.exports = __webpack_public_path__ + "static/media/kingdom-list-is-empty.805c606f.png";